import 'css-chunksrc/client/scenes/projectVirtualResourceAddition/styles.scss';export default {
  "title": "_title_czlik_1",
  "label": "_label_czlik_9",
  "row": "_row_czlik_15",
  "forms": "_forms_czlik_27",
  "formsOverflow": "_formsOverflow_czlik_38",
  "group": "_group_czlik_42",
  "text": "_text_czlik_46",
  "name": "_name_czlik_51",
  "main": "_main_czlik_57",
  "buttons": "_buttons_czlik_64",
  "button": "_button_czlik_64",
  "addResourceButton": "_addResourceButton_czlik_78"
};